import { React, UseState, UseEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PageContent from 'layouts/PageContent';
import SalesRepFollowUpDash from './SalesRepFollowUpDash';

const SalesRepFollowUpScreen = (props) => {
  const {t, i18n} = useTranslation(['salesPerformance', 'common']);
  
  return (
    <PageContent title={t('salesPerformance:SalesRepFollowUp')}>
      <SalesRepFollowUpDash />
    </PageContent>
  )
}

export default SalesRepFollowUpScreen;